import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { PaprikaFreshness } from '../../styles/theme';
import Feather from '@expo/vector-icons/Feather';

interface Props {
  count: number;
}

export function UrgencyBadge({ count }: Props) {
  const { t } = useTranslation();

  if (count > 0) {
    const f = PaprikaFreshness.urgent;
    return (
      <View style={[styles.badge, { backgroundColor: f.bg }]}>
        <View style={[styles.dot, { backgroundColor: f.dot }]} />
        <Text style={[styles.text, { color: f.text }]}>{count}</Text>
      </View>
    );
  }

  const f = PaprikaFreshness.fresh;
  return (
    <View style={styles.checkRow}>
      <Feather name="check" size={12} color={f.dot} />
      <Text style={[styles.textCheck, { color: f.text }]}>{t('pantry.zoneUpToDate')}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 999,
  },
  text: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 10.5,
  },
  checkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  textCheck: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 10.5,
  },
});
